<template lang="html">

  <section class="menu-lateral" :showmenu="showMenu" :style="styles.bgmenu">

    <div class="contenedor-logo row-between" :style="styles.backgroundWhite">
      <router-link to="/"><img :src="logo"></router-link>
      <a @click="toggleMenu" class="toggle-menu">
        <span :style="styles.bgBasic"></span>
        <span :style="styles.bgBasic"></span>
        <span :style="styles.bgBasic"></span>
        <next></next>
      </a>
    </div>
    
    <div class="contenedor-enlaces" :style="styles.colorWhite">

      <router-link to="/" class="enlace-el -father -to-home">Inicio</router-link>
      
      <!-- VALIDACIONES -->
      <router-link :to="$t('enlaces.validaciones')" class="enlace-el -father" v-if="!brand.hideInMenu.validaciones.pendientes || !brand.hideInMenu.validaciones.validadas || !brand.hideInMenu.validaciones.rechazadas">
        {{(brand.menunames.validaciones) ? brand.menunames.validaciones : 'Validaciones'}}
      </router-link>
      <div class="childrens">
        <router-link v-if="!brand.hideInMenu.validaciones.pendientes" :to="$t('enlaces.validaciones')+'/pendientes'" class="enlace-el -children">Pendientes</router-link>
        <router-link v-if="!brand.hideInMenu.validaciones.validadas" :to="$t('enlaces.validaciones')+'/validadas'" class="enlace-el -children">Validadas</router-link>
        <router-link v-if="!brand.hideInMenu.validaciones.rechazadas" :to="$t('enlaces.validaciones')+'/rechazadas'" class="enlace-el -children">Rechazadas</router-link>
      </div>

      <!-- ASIGNACIONES -->
      <router-link :to="$t('enlaces.asignaciones')" class="enlace-el -father" v-if="(!brand.hideInMenu.asignaciones.pendientes || !brand.hideInMenu.asignaciones.realizadas) && totales.coordinadorDePractica">
        Asignaciones
      </router-link>
      <div class="childrens">
        <router-link v-if="!brand.hideInMenu.asignaciones.pendientes && totales.coordinadorDePractica" :to="$t('enlaces.asignaciones')+'/pendientes'" class="enlace-el -children">Pendientes</router-link>
        <router-link v-if="!brand.hideInMenu.asignaciones.realizadas && totales.coordinadorDePractica" :to="$t('enlaces.asignaciones')+'/realizadas'" class="enlace-el -children">Realizadas</router-link>
      </div>

      <!-- ASIGNACIONES HISTORICO -->
      <router-link :to="$t('enlaces.asignaciones_historico')" class="enlace-el -father" v-if="(!brand.hideInMenu.asignaciones.pendientes || !brand.hideInMenu.asignaciones.realizadas) && totales.coordinadorDePractica">
        Asignaciones histórico
      </router-link>
      <div class="childrens">
        <router-link v-if="!brand.hideInMenu.asignaciones.pendientes && totales.coordinadorDePractica" :to="$t('enlaces.asignaciones_historico')+'/pendientes'" class="enlace-el -children">Pendientes</router-link>
        <router-link v-if="!brand.hideInMenu.asignaciones.realizadas && totales.coordinadorDePractica" :to="$t('enlaces.asignaciones_historico')+'/realizadas'" class="enlace-el -children">Realizadas</router-link>
      </div>

      <!-- OFERTAS TUTORES -->
      <router-link :to="$t('enlaces.ofertas_tutor')" class="enlace-el -father" v-if="totales.coordinadorDePractica">Ofertas de Prácticas</router-link>
      
      <!-- TUTORADOS -->
      <router-link :to="$t('enlaces.tutorados')" class="enlace-el -father" 
      v-if="brand.ordenElementosDashboard != 'nebrija' || !(totales.coordinadorDePractica && !totales.tutorAcademico)">Tutorados</router-link>
      <div class="childrens" v-if="brand.ordenElementosDashboard != 'nebrija' || !(totales.coordinadorDePractica && !totales.tutorAcademico)">
        <router-link :to="$t('enlaces.tutorados')+'/en-curso'" class="enlace-el -children">Prácticas en curso</router-link>
        <router-link :to="$t('enlaces.tutorados')+'/en-evaluacion'" class="enlace-el -children">Pendiente de cierre</router-link>
        <router-link :to="$t('enlaces.tutorados')+'/evaluados'" class="enlace-el -children">Cerrados</router-link>
      </div>
      
      <!-- TUTORADOS HISTORICO -->
      <router-link :to="$t('enlaces.tutorados_historico')" class="enlace-el -father" 
      v-if="brand.ordenElementosDashboard != 'nebrija' || !(totales.coordinadorDePractica && !totales.tutorAcademico)">Tutorados histórico</router-link>
      <div class="childrens" v-if="brand.ordenElementosDashboard != 'nebrija' || !(totales.coordinadorDePractica && !totales.tutorAcademico)">
        <router-link :to="$t('enlaces.tutorados_historico')+'/en-curso'" class="enlace-el -children">Prácticas en curso</router-link>
        <router-link :to="$t('enlaces.tutorados_historico')+'/en-evaluacion'" class="enlace-el -children">Pendiente de cierre</router-link>
        <router-link :to="$t('enlaces.tutorados_historico')+'/evaluados'" class="enlace-el -children">Cerrados</router-link>
      </div>

      <!-- MENU UTILIDADES (SOLO NEBRIJA) -->
      <label class="enlace-el -father" v-if="brand.hasUtilidades && totales.tutorAcademico">Utilidades</label>
      <div class="childrens" v-if="brand.hasUtilidades && totales.tutorAcademico">
        <a class="enlace-el -children" v-bind:href="$t('enlaces.static')+'/doc/brands/nebrija/EOS6.2_Procedimiento_Gestion_practicas_y_Asesoramiento_v5.pdf'" target="_blank">Procedimiento de Gestión de prácticas y Asesoramiento</a>
        <a class="enlace-el -children" v-bind:href="$t('enlaces.static')+'/doc/brands/nebrija/EOS6.3_Informe_memoria_finalizacion_practicas_externas_Anexo_2.pdf'" target="_blank">Informe Memoria finalización de prácticas externas</a>
      </div>
      
      <!-- Seguimiento comunicaciones -->
      <router-link :to="$t('enlaces.seguimiento_comunicaciones')" class="enlace-el -father">Seguimiento comunicaciones</router-link>
      
      <!-- Seguimiento encuestas (solo coordinadores) -->
      <router-link :to="$t('enlaces.seguimiento_encuestas')" class="enlace-el -father" v-if="totales.coordinadorDePractica">Seguimiento encuestas</router-link>

      <router-link :to="$t('enlaces.miperfil')" class="enlace-el -father" v-if="brand.hasMiPerfil">Mi perfil</router-link>

      <router-link :to="$t('enlaces.encuestas')" class="enlace-el -father" v-if="brand.hasMiPerfil">Encuestas</router-link>

      <div class="contenedor-favoritos" v-if="favoritos.length > 0">

        <h3 class="enlace-el -father">Favoritos</h3>

        <div class="contenedor-enlaces">

          <template v-for="(fav, key) in favoritos">

            <span>

              <button title="Borrar favorito" class="borrar-fav" @click="toggleFavoritos(fav)">✕</button>

              <router-link :to="$t('enlaces.ficha')+'/'+fav.idPractica" class="enlace-el -children">{{fav.nombreEstudiante}}</router-link>

            </span>

          </template>

        </div>

      </div>


    </div>

  </div>


<p class="version">{{version}}</p>

</section>

</template>

<script lang="js">

  import {mapActions, mapGetters} from 'vuex';

  import next from '@/components/parts/icons/next';

  export default  {
    name: 'menu-lateral',
    computed:{
      ...mapGetters({
        showMenu : 'getShowMenu',
        logo : 'getLogoColor',
        styles : 'getStyles',
        favoritos : 'getFavoritos',
        version : 'getVersion',
        brand : 'getBrand',
        totales : 'getTotales'
      })
    },
    methods :{
      ...mapActions(['toggleMenu','toggleFavoritos','setMenu']),
      checkMenu : function(){
        var width = $(window).width();
        if(width <= 1024){
          this.setMenu(false);
        }
      }
    },
    components:{
      'next' : next
    },
    watch:{
      '$route' : function(){
        this.checkMenu();
      }
    }
  }
</script>

<style scoped lang="scss">

  @import '@/assets/css/colors.scss';

  .menu-lateral {
    width: 100%;
    max-width: 240px;
    height: 100%;
    min-height: 100vh;
    max-height: 100vh;
    position: absolute;
    left: -240px;
    top: 0;
    will-change: transform;
    transition: .5s;
    transition-timing-function: ease-in-out;
    z-index: 8;
    
    

    &[showmenu=true]{
      transform: translateX(100%);
    }
  }
  
  .contenedor-logo{
    width: 100%;
    text-align: left;
    padding: 20px;
    position: relative;
    height: $top-height;
    margin-bottom: 10px;

    > a{
      width: 100%;
      max-width: 130px;
      display: block;
      max-height: 50px;
    }
    
    img{
      max-width: 130px;
      max-height: 50px;
      display: block;
    }

    .toggle-menu{
      width: 32px;
      height: 22px;
      display: inline-block;
      position: relative;
      cursor: pointer;
      transform: translateX(65px);
      transition: .5s;
      transition-timing-function: ease-in-out;

      span{
        height: 2px;
        width: 100%;
        display: inline-block;
        background: blue;
        position: absolute;
        left: 0;
        top: 0;
        padding-right: 12px;
      }

      span:nth-child(2){
        top: 50%;
        margin-top: -1px;
      }

      span:last-of-type{
        top: auto;
        bottom: 0;
      }
      
      svg{
        top: 50%;
        right: -15px;
        position: absolute;
        transform: translate(0px,-50%);
        width: 12px;
      }

    }

  }

  [showmenu=true] .contenedor-logo{
    .toggle-menu{
      transform: translateX(0px);
      svg{
        transform: translate(-50px,-50%) rotate(-180deg);
      }
    }
  }

  .contenedor-enlaces{
    width: 100%;
    text-align: left;
    overflow: scroll;
    overflow-x: hidden;
    max-height: calc(100vh - 110px)
  }

  .enlace-el{
    width: 100%;
    display: block;
    cursor: pointer;
    font-weight: 300;
    font-size: 16px;

    &.router-link-active{
      background:rgba(0,0,0,.3);
    }

    &.router-link-active.-to-home{
      background:rgba(0,0,0,0);
    }

    &.router-link-exact-active{
      background:rgba(0,0,0,1);
      font-weight: bold;
    }

    &:hover{
      background:rgba(0,0,0,.5);
    }

    &.-father{
      /*border-top: 1px solid rgba(255,255,255,.2);*/
      padding:10px 20px;
    }
    &.-father:first-of-type{
      border:none;
    }

    &.-children{  
      padding: 10px 0 10px 40px;
      font-size: 14px;

    }
  }

  .contenedor-favoritos{

    span{
      position: relative;
      display: block;
    }

    .-children{
      font-size: 13px;
      max-width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .borrar-fav{
      position: absolute;
      left: 10px;
      top: 50%;
      width: 20px;
      height: 20px;
      border: 1px solid white;
      border-radius: 50%;
      background: none;
      font-size: 12px;
      transform: translateY(-50%);
      opacity: 0;
      transition: .5s;
      cursor: pointer;
      outline: none;
    }

    span:hover .borrar-fav{
      opacity: 1;
    }
  }

  @media screen and (max-width: 1400px){
    .contenedor-logo{
      padding: 10px;
      height: 75px;
    }
    .contenedor-enlaces{
      max-height: calc(100vh - 85px);
    }
  }

  @media screen and (max-width: 1024px){
    .menu-lateral {
      &[showmenu=true]{
        box-shadow: 1px 2px 8px -2px rgba(0, 0, 0, 0.2)
      }
    }
    
  }



</style>



// WEBPACK FOOTER //
// src/components/parts/menu-lateral.vue